module.exports = __webpack_public_path__ + "static/media/celabrate_blue.51f6fd1e.svg";